import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import "react-quill/dist/quill.snow.css";
import store, { persistor } from "./redux/store/store";
import { MasterLayout } from "./layout/MasterLayout";
import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material";
import { LicenseInfo } from "@mui/x-data-grid-pro";

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_X_LICENSE_KEY as string);
const theme = createTheme({
  palette: {
    primary: { main: "#34336c" },
  },
  typography: {
    button: {
      textTransform: "none",
    },
  },
});

function App() {
  return (
    <React.Fragment>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}></PersistGate>
        <BrowserRouter>
          <ThemeProvider theme={theme}>
            <MasterLayout></MasterLayout>
          </ThemeProvider>
        </BrowserRouter>
      </Provider>
    </React.Fragment>
  );
}

export default App;
